import DeskReservationLanding from './DeskReservationLanding';
import Route from './route';

export default {
  RenderProp: DeskReservationLanding,
  mainRoute: Route,
};
